import { createEvent, createStore, sample } from 'effector'
import { pushFx } from 'src/infastruct/effector-utils/attach-router'
import { useEvent, useStore } from 'effector-react'
import { $currentPath, onRouteChangeStart } from '@entities/route/model'
import {
    cancelSuggestionsSearch,
    searchSuggestion,
    selectSuggestion,
    startSuggestionFx,
    suggestionsSearchEvent,
    suggestionsSearchModel
} from 'src/features/suggestions/model'

const onResetSearchText = createEvent()
const onChangeSearchText = createEvent<string>()
const onStartSearching = createEvent()

export const $searchText = createStore('', { name: 'search-text' }).reset(onResetSearchText)

export const openSearchSection = createEvent()
export const closeSearchSection = createEvent()
export const $isOpenedSearchSection = createStore(false)
    .on(openSearchSection, () => true)
    .on(closeSearchSection, () => false)

sample({
    clock: selectSuggestion,
    target: closeSearchSection
})
sample({
    clock: searchSuggestion,
    target: closeSearchSection
})

sample({
    clock: onChangeSearchText,
    fn: (clock) => clock as string,
    target: $searchText
})

sample({
    clock: $searchText,
    filter: (term) => term?.length >= 3,
    fn: (term) => ({ term }),
    target: suggestionsSearchEvent
})

sample({
    clock: $searchText,
    filter: (term) => term?.length < 3,
    fn: (term) => ({ term }),
    target: suggestionsSearchModel.reset
})

sample({
    clock: closeSearchSection,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    target: [$searchText.reinit!, cancelSuggestionsSearch]
})

sample({
    clock: onStartSearching,
    source: $searchText,
    filter: (searchText) => searchText.length > 2,
    fn: (searchText) => ({
        pathname: '/catalog/search',
        query: {
            q: searchText
        }
    }),
    target: pushFx
})

sample({
    clock: onRouteChangeStart,
    target: onResetSearchText
})

sample({
    clock: $currentPath,
    target: closeSearchSection
})

sample({
    clock: startSuggestionFx.done,
    target: closeSearchSection
})

export const useOnChangeSearchText = () => useEvent(onChangeSearchText)
export const useOnStartSearching = () => useEvent(onStartSearching)
export const useSearchText = () => useStore($searchText)
